import { Component, inject, input, output } from '@angular/core';

import { OverlayModule } from '@angular/cdk/overlay';
import { CdkMenuModule } from '@angular/cdk/menu';
import { RouterLink } from '@angular/router';
import { I18nService, type SupportedLocale } from '@welma-education/i18n';
import { AvatarComponent, AvatarSize } from '../avatar/avatar';
import { IconComponent } from '../icon/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'wma-profile-dropdown',
  templateUrl: './profile-dropdown.component.html',
  imports: [
    OverlayModule,
    CdkMenuModule,
    RouterLink,
    AvatarComponent,
    IconComponent,
    TranslatePipe,
  ],
})
export class ProfileDropdownComponent {
  private readonly i18nService = inject(I18nService);

  user = input.required<{ picture?: string; name?: string }>();
  size = input<AvatarSize>('sm');
  showDocsLink = input(false);
  logout = output<void>();

  readonly locales = this.i18nService.locales;
  readonly currentLocale = this.i18nService.currentLocale;

  emitLogout(): void {
    this.logout.emit();
  }

  switchLocale(locale: SupportedLocale): void {
    this.i18nService.switchLocale(locale);
  }

  getCurrentLanguageLabel(): string {
    return this.i18nService.getLanguageLabel(this.currentLocale());
  }

  isRtl(): boolean {
    return this.currentLocale() === 'ar';
  }
}
